// Plain <button> classes rather than AreaButton: nothing else needs this full-width pill size.
const PILL_BUTTON_BASE_CLASS =
    "flex w-full items-center justify-center rounded-pill px-s py-xs text-l font-semibold cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 focus-visible:outline-2 focus-visible:outline-offset-2";

export const PRIMARY_PILL_BUTTON_CLASS = `${PILL_BUTTON_BASE_CLASS} border-none bg-p6-orange text-white focus-visible:outline-p6-orange-darker`;

export const SECONDARY_PILL_BUTTON_CLASS = `${PILL_BUTTON_BASE_CLASS} border border-p6-grey-mid bg-white text-p6-grey-dark hover:bg-background-light focus-visible:outline-p6-orange`;

export const TEXT_INPUT_CLASS =
    "border-p6-grey-lightest h-[var(--size-input-l)] w-full rounded-xsmall-container border bg-white p-s text-l text-p6-grey-darkest placeholder:text-p6-grey-mid focus-visible:outline-2 focus-visible:outline-p6-orange focus:outline-none";

export const CODE_INPUT_CLASS = `${TEXT_INPUT_CLASS} uppercase placeholder:normal-case`;

export const LOGIN_COLUMN_CLASS = "flex w-full max-w-[var(--size-login-column)] flex-col items-center";
